import { render, staticRenderFns } from "./EditaServicePainel.vue?vue&type=template&id=90b7386a"
import script from "./EditaServicePainel.vue?vue&type=script&lang=js"
export * from "./EditaServicePainel.vue?vue&type=script&lang=js"
import style0 from "./EditaServicePainel.vue?vue&type=style&index=0&id=90b7386a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports